import { Trans } from "react-i18next";
import { redirect, useLoaderData, useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { getPlatformCurrent } from "api/methods";
import { Button } from "atoms/button/Button";
import { Icon } from "atoms/icon/Icon";
import Warning from "atoms/icon/icons/ic_warning_ol.svg";
import { queryClient } from "pages/Root";
import Services from "services/Services";
import { waitObj } from "toolbox/Promise";
import { defineLoader } from "toolbox/Router";
import { isNativeMobileApp } from "utils/platform.helpers";
import { useLogout } from "utils/useLogout";

type LoaderData = Awaited<ReturnType<typeof deactivatedLoader>>;
export const deactivatedLoader = defineLoader(async () => {
  const platform = await queryClient.ensureQueryData({ ...getPlatformCurrent.keyed() });

  if (platform.active) {
    throw redirect("/home");
  }

  return waitObj({ platform });
});

export const Deactivated = () => {
  const { platform } = useLoaderData() as LoaderData;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const logout = useLogout();

  // When a platform is deactivated, we want to force the user's token to get
  // reset in case we reassign the domain later to a different platform
  if (!isNativeMobileApp()) {
    Services.auth.clearAll();
  }

  return (
    <div className="flex h-screen flex-col p-4 pt-[calc(56px_+_env(safe-area-inset-top))]">
      <div className="flex flex-grow flex-col items-center">
        <div className="mb-8">
          <Icon svg={Warning} size="large" color="red" />
        </div>
        <div className="text-body mx-4 mb-8 text-center">
          <Trans
            i18nKey="deactivated.message"
            values={{ platformName: platform.name }}
            components={{ bold: <span className="font-bold" /> }}
          />
        </div>
      </div>
      {isNativeMobileApp() && (
        <div className="sticky bottom-0 mb-8 flex w-full flex-col gap-2">
          <Button onClick={() => navigate("/platform-selector")} fullWidth>
            {t("deactivated.changeLocation")}
          </Button>
          <Button fullWidth style="secondary" onClick={logout}>
            {t("deactivated.logout")}
          </Button>
        </div>
      )}
    </div>
  );
};
